export default "__VITE_ASSET__Cwx0jLj7__"